module.exports = __webpack_public_path__ + "static/media/Sayan_logo.7b6e83b8.png";